import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    name: "gallery",
    _selector: "[data-slideshow-gallery-id]",
    init() {
        const swipers = document.querySelectorAll(this._selector);

        if (swipers.length) {
            for (let i = 0; i < swipers.length; i++) {
                let swiperId = swipers[i].getAttribute("data-slideshow-gallery-id");

                // console.log(swiperId);

                let el = document.querySelector(`[data-slideshow-gallery-id="${swiperId}"]`)
                let slides = el.getAttribute("data-slides") ?? 1;

                let config = {
                    autoHeight: true,
                    loop: false,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination-'+swiperId,
                        clickable: true,
                    },
                    // breakpoints: {
                    //     768: {
                    //         loop: false,
                    //         slidesPerView: 3,
                    //     },
                    // },
                    navigation: {
                        nextEl: ".swiper-button-next-"+swiperId,
                        prevEl: ".swiper-button-prev-"+swiperId,
                        disabledClass: "swiper-button-disabled"
                    },
                }

                let swiper = new Swiper(el, config);

                setTimeout(this.setVideoHeight, 250);

                window.onresize =  setTimeout(this.setVideoHeight, 1000);
            }

        }
    },

    setVideoHeight()
    {
        const swipers = document.querySelectorAll('[data-slideshow-gallery-id]');

        for (let i = 0; i < swipers.length; i++) {
            let swiperId = swipers[i].getAttribute("data-slideshow-gallery-id");
            let el = document.querySelector(`[data-slideshow-gallery-id="${swiperId}"]`);

            const wrapper = el.querySelector(`.swiper-wrapper`);
            const videos = el.querySelectorAll('video');

            videos.forEach((v) => v.style.height = wrapper.clientHeight+'px');
        }

    }

};
